let _getPushToken
let pushToken
let pushTokenPromise
let lastFailedAt
let isInitialized = false

const PUSH_TOKEN_RETRY_INTERVAL_MS = 5 * 60 * 1000

export const initPushToken = getPushToken => {
  _getPushToken = getPushToken
  isInitialized = true
  // Allow immediate first real fetch after initialization.
  if (!pushToken) {
    pushTokenPromise = undefined
    lastFailedAt = undefined
  }
}

export const setPushToken = nextPushToken => {
  pushToken = nextPushToken
  pushTokenPromise = undefined
  lastFailedAt = nextPushToken ? undefined : Date.now()
}

export const getPushToken = async () => {
  if (pushToken) return pushToken
  // apiRequest can happen before initPushToken is configured in native app startup.
  // In that case return null, but do not cache failure.
  if (!isInitialized || !_getPushToken) {
    return null
  }
  if (
    pushToken === null &&
    lastFailedAt &&
    Date.now() - lastFailedAt < PUSH_TOKEN_RETRY_INTERVAL_MS
  ) {
    return null
  }
  if (!pushTokenPromise) {
    pushTokenPromise = (async () => {
      try {
        const token = await _getPushToken()
        setPushToken(token || null)
      } catch (e) {
        setPushToken(null)
      }
      return pushToken
    })()
  }
  return await pushTokenPromise
}
